import { useEffect, useState } from "react"

import { useFindIngestionSettingsQuery } from "~/pages/Admin/Ingestion/ProductImport/hooks/useFindIngestionSettings"
import { useFindOrganizationUsersQuery } from "~/pages/Admin/Ingestion/ProductImport/hooks/useFindOrganizationUsersQuery"
import { ProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"

export const ProductImportProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [owners, setOwners] = useState<string[]>([])

  const { data: ingestionSettings, isPending: isIngestionSettingsLoading } =
    useFindIngestionSettingsQuery()

  const { data: ownersResponse, isPending: isLoadingOwners } =
    useFindOrganizationUsersQuery()

  useEffect(() => {
    if (ownersResponse?.data) {
      setOwners(ownersResponse.data.map((element) => element.email))
    }
  }, [ownersResponse])

  return (
    <ProductImportContext.Provider
      value={{
        isLoadingOwners,
        owners,
        ingestionSettings: ingestionSettings?.data,
        isIngestionSettingsLoading,
        setOwners,
      }}
    >
      {children}
    </ProductImportContext.Provider>
  )
}
